import Slider from "react-slick";
import { Sparkles, ArrowUpRight } from "lucide-react";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// import "./WinnersLand.css";

import heroImg from "../../../Images/hero-villa.jpg";
import cityImg from "../../../Images/city-skyline.jpg";
import interiorImg from "../../../Images/apartment-interior.jpg";
import towerImg from "../../../Images/property-tower.jpg";

export function WinnersBanner() {
  const slides = [
    {
      image: heroImg,
      title: "Find homes that feel like yours.",
      desc: "Curated luxury apartments, smart investments and future-ready communities.",
    },
    {
      image: cityImg,
      title: "Invest in India's fastest growing cities.",
      desc: "Premium opportunities across top urban destinations.",
    },
    {
      image: interiorImg,
      title: "Luxury spaces crafted for modern living.",
      desc: "Experience comfort, design and long-term value.",
    },
    {
      image: towerImg,
      title: "Future-ready real estate investments.",
      desc: "Verified projects with transparent pricing and strong ROI.",
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 1000,
    fade: true,
    arrows: false,
    pauseOnHover: false,
  };

  return (
    <section className="ws-hero-slider">
      <Slider {...settings}>
        {slides.map((slide, index) => (
          <div key={index}>
            <section className="ws-hero">
              <div className="ws-hero-bg">
                <img
                  src={slide.image}
                  alt={slide.title}
                  width={1600}
                  height={1024}
                />
              </div>

              <div className="ws-hero-overlay" />
              <div className="ws-hero-glow-a" />
              <div className="ws-hero-glow-b" />

              <div className="ws-hero-content">
                <span className="ws-hero-tag">
                  {/* <Sparkles size={14} /> */}
                  Featured · India's premier property platform
                </span>

                <h1 className="ws-hero-title">
                  {slide.title}
                </h1>

                <p className="ws-hero-desc">
                  {slide.desc}
                </p>

                <div className="ws-hero-btns">
                  <button className="ws-btn-primary">
                    Browse Properties
                    <ArrowUpRight size={18} />
                  </button>

                  {/* <button className="ws-btn-ghost">
                    Invest Now
                  </button> */}
                </div>
              </div>

              <div className="ws-hero-scroll">
                <span>Scroll</span>
                <div className="ws-hero-scroll-line" />
              </div>
            </section>
          </div>
        ))}
      </Slider>
    </section>
  );
}